import * as TYPES from './countyFilterTypes';
import { fetchCountyFilters } from '../../api/ContentApi';
import { LocalStorage } from 'utils';
import queryString from 'query-string';

const Storage = new LocalStorage();
// Helper function to get search params from a URL
const normalizeRegion = value =>
  (value || '')
    .toString()
    .trim()
    .replace(/\s+/g, '')
    .toLowerCase();

export const fetchFilters = () => {
  return async dispatch => {
    dispatch({ type: TYPES.FILTER_REQUESTED_STARTED });

    try {
      const countyFilters = await fetchCountyFilters();

      if (!countyFilters || !Array.isArray(countyFilters)) {
        dispatch({ type: TYPES.FILTER_ERROR });
        return [];
      }

      const cookie = Storage.getJSON(TYPES.FILTER_COUNTY_COOKIE) || {};
      Storage.set(TYPES.FILTER_COUNTY_COOKIE, { ...cookie, categoryList: countyFilters });

      const county = queryString.parse(window.location.search || '');
      const regionFromUrl = normalizeRegion(county.region);

      dispatch({ type: TYPES.FILTER_REQUESTED_FINISH, categoryList: countyFilters });

      if (regionFromUrl) {
        const countyFromUrl = countyFilters.find(
          ({ name }) => normalizeRegion(name) === regionFromUrl
        );

        if (countyFromUrl) {
          const currentCookie = Storage.getJSON(TYPES.FILTER_COUNTY_COOKIE) || {};
          // Update the cookie with the selected county from the URL
          Storage.set(TYPES.FILTER_COUNTY_COOKIE, {
            ...currentCookie,
            selected: countyFromUrl
          });

          dispatch({ type: TYPES.FILTER_SELECTED, selected: countyFromUrl });
        }
      }

      return countyFilters;
    } catch (e) {
      dispatch({ type: TYPES.FILTER_ERROR });
      throw e;
    }
  };
};

export const setMessage = (message, lastHitId) => {
  return dispatch => {
    dispatch({ type: TYPES.FILTER_SET_MESSAGE, message, lastHitId });
  };
};

export const setSelectedFilter = (filter, position, hideCounty = false) => {
  return async dispatch => {
    if (!filter) return;

    dispatch({ type: TYPES.FILTER_SET_SELECTED });

    const cookie = Storage.getJSON(TYPES.FILTER_COUNTY_COOKIE) || {};
    Storage.set(TYPES.FILTER_COUNTY_COOKIE, { ...cookie, selected: filter });

    const selectedRegion = (filter && filter.name ? filter.name : '').replace(/\s+/g, '');

    let nextUrl = window.location.pathname;
    if (filter.id !== 2) {
      nextUrl = hideCounty
        ? window.location.pathname + '?region=' + selectedRegion
        : '?region=' + selectedRegion;
    } else {
      nextUrl = window.location.pathname + '?region=';
    }

    const current = new URL(window.location.href);
    const next = new URL(nextUrl, window.location.origin);

    if (
      current.pathname === next.pathname &&
      normalizeRegion(current.search) === normalizeRegion(next.search)
    ) {
      dispatch({ type: TYPES.FILTER_SELECTED, selected: filter });
      return;
    }

    window.location.assign(nextUrl);
  };
};

export const resetFilter = category => {
  return dispatch => {
    const cookie = Storage.getJSON(TYPES.FILTER_COUNTY_COOKIE);
    const newCookie = { ...cookie, selected: category, last: category, current: category };
    Storage.set(TYPES.FILTER_COUNTY_COOKIE, newCookie);
    dispatch({ type: TYPES.FILTER_RESET, category });
  };
};

export const setCurrentFilter = (filter, position) => {
  return dispatch => {
    dispatch({ type: TYPES.FILTER_SET_CURRENT });
    dispatch({ type: TYPES.FILTER_CURRENT, value: filter });
    if (position) {
      dispatch({ type: TYPES.FILTER_ANIMATION_START, value: position });
    }
  };
};

export const setHeaderHover = hovering => {
  return dispatch => {
    dispatch({ type: TYPES.FILTER_HEADER_HOVER, value: hovering });
  };
};

export const expandCollapse = expanded => {
  return dispatch => {
    dispatch({ type: TYPES.FILTER_EXPAND_COLLAPSE, value: expanded });
  };
};

export const setAnimationDone = () => {
  return dispatch => {
    dispatch({ type: TYPES.FILTER_ANIMATION_END });
  };
};

export const setHover = hover => {
  return dispatch => {
    if (hover) {
      dispatch({ type: TYPES.FILTER_HOVER_START });
    } else {
      dispatch({ type: TYPES.FILTER_HOVER_END });
    }
  };
};

export const toggleModal = (shouldOpen = false, forceMode = false) => {
  return dispatch => {
    dispatch({
      type: TYPES.FILTER_TOGGLE_MODAL,
      value: { shouldOpen: shouldOpen, forceMode: forceMode }
    });
  };
};
